export interface Notice {
  id: number;
  type: string;
  title: string;
  content: string;
  author: string;
  createdAt: string;
  buttonTitle?: string;
  buttonText?: string;
  buttonLink?: string;
  fixed?: boolean;
}

/**
 * .png
 * Modal 3x
 * Detail 4x
 */

export const NoticeList: Array<Notice> = [
  {
    id: 40,
    type: 'notice',
    title: '방문 수령 환자 처방전 확인 방법 변경 안내',
    fixed: true,
    content: 'pickup_prescription_check_240429.png',
    author: '약국 파트너센터',
    createdAt: '2024-05-29',
    buttonText: '자세히 보기',
    buttonLink:
      'https://pilltong.notion.site/f4d6a07c88154e6984b374fa70e54849'
  },
  {
    id: 39,
    type: 'notice',
    title: '조제 수락 시 대체조제 관련 안내',
    fixed: true,
    content: 'alternative.png',
    author: '약국 파트너센터',
    createdAt: '2024-03-26',
  },
  {
    id: 38,
    type: 'notice',
    title: '비대면진료 시범사업 지침 개정안 추가 공고 안내',
    fixed: true,
    content: 'nonFaceToFaceNotice240226.png',
    author: '약국 파트너센터',
    createdAt: '2024-02-26',
    buttonText: '자세히 보기',
    buttonLink:
      'https://www.mohw.go.kr/board.es?mid=a10501010000&bid=0003&list_no=1480386&act=view'
  },
  {
    id: 37,
    type: 'notice',
    title: '처방전 확인 방법 변경 안내',
    fixed: true,
    content: 'partnershipPickup.png',
    author: '약국 파트너센터',
    createdAt: '2024-02-06'
  },
  {
    id: 36,
    type: 'notice',
    title: '비대면진료 시범사업 지침 개정',
    fixed: false,
    content: 'untactDiagnosisRevisionV2.png',
    author: '약국 파트너센터',
    createdAt: '2023-12-12',
    buttonText: '자세히 보기',
    buttonLink:
      'https://drnow-contents.oopy.io/73d17cbe-eec8-479f-9333-24919da0ea9e'
  },
  {
    id: 35,
    type: 'notice',
    title: '비대면 진료 서비스 개편 안내',
    content: 'untactDiagnosisRevision.png',
    author: '약국 파트너센터',
    createdAt: '2023-08-31',
    buttonText: '자세한 내용 확인하러 가기',
    buttonLink:
      'https://drnow-contents.oopy.io/66da380c-3fab-4310-b8a6-2ebeee886cf0'
  },
  {
    id: 30,
    type: 'update',
    title: '처방전 수정 기능 업데이트 안내',
    content: 'prescriptionModify.png',
    author: '약국 파트너센터',
    createdAt: '2023-05-23'
  },
  {
    id: 28,
    type: 'update',
    title: '결제금액 변경 기능 안내',
    content: 'resetPrice.png',
    author: '약국 파트너센터',
    createdAt: '2023-04-17'
  },
  {
    id: 27,
    type: 'notice',
    title: '대체조제 관련 공지',
    content: 'alternativeMedicine.png',
    author: '약국 파트너센터',
    createdAt: '2023-04-10'
  },
  {
    id: 26,
    type: 'notice',
    title: '닥터나우 부가세 신고 자료 조회',
    fixed: true,
    content: 'pharmacyVAT.png',
    author: '약국 파트너센터',
    createdAt: '2023-04-07'
  },
  {
    id: 13,
    type: 'update',
    title: '가격 요청탭 검색 시 "필터" 설정 기능 수정',
    content: 'defaultFilter.png',
    author: '약국 파트너센터',
    createdAt: '2022-04-08'
  },
  {
    id: 5,
    type: 'update',
    title: '처방전 접수 ON/OFF 기능 및 영업시간 수정 기능 추가',
    content: 'dutyTimeChange.png',
    author: '약국 파트너센터',
    createdAt: '2022-01-28'
  },
  {
    id: 4,
    type: 'notice',
    title: '닥터나우 조제약 배달 시 유의사항',
    content: 'pharmacyDetail.png',
    author: '약국 파트너센터',
    createdAt: '2022-01-21'
  },
];
